import { createContext, useContext, useMemo, useState } from "react";

const LIGHT_BG_OPTIONS = ["pink", "tangerine", "springGreen", "electric", "arcticBlue", "ash"];
const DARK_BG_OPTIONS = ["charcoal", "slate"];

function pickRandom<T>(arr: T[]): T {
    return arr[Math.floor(Math.random() * arr.length)];
}

type RandomBgColorState = {
    lightBg: string;
    darkBg: string;
};

const RandomBackgroundColorContext = createContext<RandomBgColorState>({
    lightBg: "bg-ash",
    darkBg: "bg-charcoal",
});

export const RandomBackgroundColorProvider = ({ children }: { children: React.ReactNode }) => {
    const [state] = useState<RandomBgColorState>(() => ({
        lightBg: `bg-${pickRandom(LIGHT_BG_OPTIONS)}`,
        darkBg: `bg-${pickRandom(DARK_BG_OPTIONS)}`,
    }));

    const value = useMemo(() => state, [state.lightBg, state.darkBg]);

    return (
        <RandomBackgroundColorContext.Provider value={value}>
            {children}
        </RandomBackgroundColorContext.Provider>
    );
};

export const useRandomBackgroundColor = () => useContext(RandomBackgroundColorContext);
